class HowToChoose extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('.how-to-choose__tab'));
    this.panels = Array.from(this.querySelectorAll('.how-to-choose__panel'));
    this.activeIndex = this.tabs.findIndex((tab) => tab.classList.contains('is-active'));
    if (this.activeIndex < 0) this.activeIndex = 0;
    this.intervalMs = (Number(this.dataset.interval) || 6) * 1000;
    this.timer = null;

    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.setActive(index, true));
    });

    if (this.tabs.length > 1) {
      this.startAutoRotate();
    }
  }

  disconnectedCallback() {
    this.stopAutoRotate();
  }

  setActive(index, userInitiated) {
    if (index !== this.activeIndex) {
      this.activeIndex = index;

      this.tabs.forEach((tab, i) => {
        const isActive = i === index;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', String(isActive));
      });

      this.panels.forEach((panel, i) => {
        panel.classList.toggle('is-active', i === index);
      });
    }

    if (userInitiated) this.startAutoRotate();
  }

  startAutoRotate() {
    this.stopAutoRotate();
    if (this.tabs.length < 2) return;

    this.timer = window.setInterval(() => {
      const next = (this.activeIndex + 1) % this.tabs.length;
      this.setActive(next, false);
    }, this.intervalMs);
  }

  stopAutoRotate() {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }
}

customElements.define('how-to-choose', HowToChoose);
